/* OBJECT & TONE: Shopify Forms 1176526 confirmed-success bridge. */
(() => {
  'use strict';
  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/trade\/?$/i.test(location.pathname)) return;
  const EVENT = 'ot_trade:application_submitted';
  const attached = new WeakSet();
  const bind = () => {
    const host = document.querySelector('[data-forms-id="forms-root-1176526"] shopify-forms-embed');
    const root = host && host.shadowRoot;
    if (!root || attached.has(root)) return;
    attached.add(root);
    let pending = null;
    let delivered = false;
    const status = value => { host.dataset.otTradeTracking = value; };
    status('ready');
    root.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !event.isTrusted || !form.checkValidity()) return;
      pending = { id: crypto.randomUUID(), at: Date.now() };
      delivered = false;
      status('awaiting-success');
    }, true);
    const inspect = () => {
      if (!pending || delivered || Date.now() - pending.at > 120000) return;
      const app = root.querySelector('[data-current-step="success"]');
      const banner = app && app.querySelector('[data-testid="banner-success"]');
      if (!banner || !banner.textContent.includes('Application received') || root.querySelector('form')) return;
      delivered = true;
      status('confirmed-success');
      const publish = () => {
        const privacy = window.Shopify && Shopify.customerPrivacy;
        if (!privacy || !privacy.analyticsProcessingAllowed() || !privacy.marketingAllowed()) {
          status('consent-blocked');
          return;
        }
        if (!Shopify.analytics || typeof Shopify.analytics.publish !== 'function') {
          status('analytics-unavailable');
          return;
        }
        try {
          Shopify.analytics.publish(EVENT, {
            form_id: '1176526',
            submission_id: pending.id,
            tracking_version: '1.0.0'
          });
          status('published');
          host.dataset.otTradeSubmissionId = pending.id;
        } catch (error) { status('publish-error'); }
      };
      if (window.Shopify && Shopify.customerPrivacy) publish();
      else if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (error) status('privacy-unavailable');
          else publish();
        });
      } else status('privacy-unavailable');
    };
    new MutationObserver(inspect).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-step'] });
  };
  bind();
  const discovery = new MutationObserver(bind);
  discovery.observe(document.documentElement, { childList: true, subtree: true });
  let attempts = 0;
  const interval = setInterval(() => {
    bind();
    if (++attempts >= 60) { clearInterval(interval); discovery.disconnect(); }
  }, 500);
})();
